/**
 * Bump a semantic version (i.e. 1.1.0)
 *
 * @param {string} version the version to bump
 * @param {string} patch the part of version to bump (major, minor, or patch)
 *
 * @returns {string} the new version
 */
export default (version, part = "patch") => {
  const regex = /\d+\.\d+\.\d+/;
  const matches = version.match(regex);
  if (!matches) return null;
  let parts = matches[0].split(".");

  switch (part) {
    case "major":
      parts = [parseInt(parts[0], 10) + 1, 0, 0];
      break;
    case "minor":
      parts[1] = parseInt(parts[1], 10) + 1;
      parts[2] = 0;
      break;
    case "patch":
      parts[2] = parseInt(parts[2], 10) + 1;
      break;
    default:
      parts = [...parts];
  }
  return version.replace(regex, parts.join("."));
};
